import { CodenovaDesktopApi } from './desktop-api.types';

let readyEventReceived = false;
const readyListeners = new Set<() => void>();

const handleReady = () => {
  readyEventReceived = true;
  readyListeners.forEach((listener) => listener());
};

if (typeof window !== 'undefined') {
  window.addEventListener('codenova-desktop-ready', handleReady);
}

export const desktopBridge = {
  get(): CodenovaDesktopApi | undefined {
    return typeof window === 'undefined' ? undefined : window.codenovaDesktop;
  },
  wasReadyEventReceived(): boolean {
    return readyEventReceived;
  },
  onReady(listener: () => void): () => void {
    readyListeners.add(listener);
    return () => readyListeners.delete(listener);
  },
};
